import { useEffect, useState } from "react";

type ThemeClass = "light" | "dark";

function useThemeClass(initialTheme: ThemeClass = "light") {
    const [theme, setTheme] = useState<ThemeClass>(() => {
        if (typeof document !== "undefined") {
            return document.documentElement.className as ThemeClass ||
                initialTheme;
        }
        return initialTheme;
    });

    useEffect(() => {
        const htmlElement = document.documentElement;

        // Create a MutationObserver to watch for class changes
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "class"
                ) {
                    const newClass = htmlElement.className;
                    setTheme((newClass || "light") as ThemeClass);
                }
            });
        });

        // Start observing the HTML element for class attribute changes
        observer.observe(htmlElement, {
            attributes: true,
            attributeFilter: ["class"],
        });

        // Cleanup observer on unmount
        return () => observer.disconnect();
    }, []);

    // Function to update the theme
    const updateTheme = (newTheme: ThemeClass) => {
        document.documentElement.className = newTheme;
        setTheme(newTheme);
    };

    return [theme, updateTheme] as const;
}

export default useThemeClass;
